import { SimpleErrorReport } from '@nrk/dh-simple-error-report'

export function createErrorReporter(name: string, isErrorReportingEnabled: boolean) {
  return new SimpleErrorReport({
    name: name,
    url: 'https://dh.nrk.no/catch',
    dryRun: !isErrorReportingEnabled
  })
}
